import React from 'react';

import { Block } from "@randajan/jet-react/dom/block";


import { Locale } from '../../../assets/Locale';
import { GrantButton } from './GrantButton/GrantButton';

import "./LoginScreen.scss";
import { useBeam } from '@randajan/bifrost/client/react';
import { bifrost } from '../../../assets/bifrost';
import { oauthBeam } from '../../../assets/beams/oauthBeam';


import { page } from '../../../assets/bases/page';
import { usePop } from '@randajan/jet-react/dom/modal';
import { LoginFail } from './LoginFail/LoginFail';
import { MagicInit } from './MagicInit/MagicInit';
import { MagicPending } from './MagicPending/MagicPending';
import { MagicSuggest } from './MagicSuggest/MagicSuggest';


const webRef = page.pull("search.webRef");

const oauthLogin = async (grantKey, userId) => {
    const href = page.get("href");
    return bifrost.tx(`/oauth/${grantKey}`, {
        userId,
        landingUri: href,
        webRef
    });

}

const findSuggest = (email, magicSuggest=[], grantsList)=>{
    if (!Array.isArray(magicSuggest)) { return; }
    const [, domain = ""] = String.jet.to(email).split("@");
    const cleanDomain = domain.toLowerCase();
    if (!cleanDomain) { return; }
    const suggest = magicSuggest.find(({ domain:suggestDomain })=>String.jet.to(suggestDomain).toLowerCase() === cleanDomain);
    if (!suggest) { return; }
    return grantsList.find(({ key })=>key === suggest.grantKey);
};

export const LoginScreen = (props) => {
    const { gdpr } = props;
    const say = Locale.use();

    const popMagic = usePop();
    const popSuggest = usePop();
    const popResult = usePop();
    const { data:oauth } = useBeam(oauthBeam);

    if (!oauth) { return null; }

    const performRedirect = async (grantKey) => {
        const { redirect, fail } = await oauthLogin(grantKey);

        if (fail) { popResult.up(<LoginFail {...fail}/>); }
        else if (redirect) { window.location = redirect; }
    }

    const initMagic = (grantKey)=>{
        const { grantsList, magicSuggest } = oauth;

        const onUserIdDirect = async userId=>{
            popMagic.down();
            popSuggest.down();
            const { fail } = await oauthLogin(grantKey, userId);
            popResult.up(fail ? <LoginFail {...fail}/> : <MagicPending userId={userId}/>);
        };

        const onUserId = (userId)=>{
            const grantSuggest = findSuggest(userId, magicSuggest, grantsList);
            if (!grantSuggest) { return onUserIdDirect(userId); }

            const onSubmit = async _=>{
                popMagic.down();
                popSuggest.down();
                return performRedirect(grantSuggest.key);
            };

            popMagic.down();
            popSuggest.up(
                <MagicSuggest onMagic={_=>onUserIdDirect(userId)}>
                    <GrantButton {...grantSuggest} onSubmit={onSubmit}/>
                </MagicSuggest>
            );
        };

        popMagic.up(
            <MagicInit
                onUserId={onUserId}
            />
        );
    };

    return (
        <Block level={0} className="LoginScreen popScreen" caption={say("oauthLoginScreenCaption")}>
            <div className="buttons">
                {oauth.grantsList?.map((grant)=>{
                    const { name, key } = grant;
                    const onSubmit = name === "magic" ? _=>initMagic(key) : _=>performRedirect(key);
                    return <GrantButton {...grant} key={key} onSubmit={onSubmit}/>
                })}
            </div>
            {
                gdpr && <div className="gdpr">
                    <span>{say("oauthLoginScreenGdprAccept")}</span>
                    <span>{gdpr}</span>
                </div>
            }
            <div>
                <span className="claim">{say("oauthLoginScreenClaim")}</span>
            </div>
        </Block>
    )
}
